import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ScorePluginService } from './score.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../modal/modal.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'score-edit',
  templateUrl: './score-edit.component.html',
  standalone: false
})
export class ScoreEditPageComponent extends BaseModalPageComponent implements OnInit, OnDestroy {
  plugin: any;
  editForm: UntypedFormGroup;
  scoreOptions = [1, 2, 3, 4, 5];
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public processing = false;

  private sub = new Subscription();

  @ViewChild('scoreModal', { static: true }) scoreModal: ModalComponent;
  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('pluginDeleteConfirm', { static: true }) pluginDeleteConfirm: any;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: ScorePluginService
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateScore(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public onClose(e: any) {
    this.editForm.markAsTouched();
  }

  public openScoreSelector(controlName: string) {
    const control = this.editForm.controls[controlName];
    const options = this.scoreOptions.map((score) => ({ value: score, label: score.toString() }));
    this.openSelector(this.scoreModal, options, control.value);
  }

  public selectScoreMenu(item: any) {
    this.editForm.controls.score.setValue(item.value?.value);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([this.inspectionsRoute, this.inspectionId, 'points', this.pointId, 'plugins', this.pluginId, 'editjson']);
  }

  gotoEditPage() {
    return this.router.navigate([this.inspectionsRoute, this.inspectionId, 'points', this.pointId, 'plugins', this.pluginId, 'edit']);
  }

  public deletePlugin() {
    this.pluginService.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }

  public openDeleteConfirm() {
    this.pluginDeleteConfirm.open();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);
      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);
      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();
      this.pluginId = pluginId;

      this.initData();
    });
  }

  private initData() {
    this.pluginService.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      score: new UntypedFormControl(this.plugin.config.Score.Score),
      comment: new UntypedFormControl(this.plugin.config.Score.Comment)
    });
  }
}
